<template>
  <el-card class="box-card guide_card">
    <div slot="header" class="clearfix">
      <span> <i class="el-icon-question" /> Подсказки </span>
    </div>
    <div class="guide">
      <p>{{ text }}</p>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'Hint',
  props: {
    text: {
      type: String,
      default:
        'При создании заявки, старайтесь. указывать информацию как можно полней. От этого зависит количество возможных контактов',
    },
  },
}
</script>

<style lang="sass">
.guide_card
  padding: 0 20px
  .guide
      margin-top: 20px
      padding: 0 10px
      border: 1px solid #F2F4F6
      border-bottom: 4px solid #F2F4F6
      border-radius: 4px
</style>
